import { hasAnyRole, hasRole } from "@/lib/normalize-user-data";
import { hasFeatureAccess, FeatureAccess } from "@/lib/subscription-feature-guards";

export type PanelSwitcherSubscription = {
  isNobility?: boolean;
  isRoyalty?: boolean;
  isImperial?: boolean;
  subscriptionTier?: string;
  subscriptionStatus?: string;
};

/** Jobs + professional profile hub (dedicated /professional panel). */
export const PROFESSIONAL_PANEL_PATH = "/professional/dashboard";

/** Course / teaching entry when user has INSTRUCTOR (not the jobs/profile hub).
 *  Points at the panel root, not the create form — the panel is live now, so
 *  dropping someone straight into "new course" skips their existing content. */
export const TEACHING_ENTRY_PATH = "/instructor";

export function canAccessSellerPanel(
  user: unknown,
  sub: PanelSwitcherSubscription
): boolean {
  if (!user || typeof user !== "object") return false;
  if (hasAnyRole(user, ["ADMIN"])) return true;
  return (
    hasAnyRole(user, ["SELLER", "PREMIUM_SELLER"]) &&
    hasFeatureAccess(sub.subscriptionTier, FeatureAccess.SELL_CURRICULUM, {
      subscriptionStatus: sub.subscriptionStatus,
    })
  );
}

/** Dedicated /professional panel access. */
export function canAccessProfessionalJobsProfile(
  user: unknown,
  sub: PanelSwitcherSubscription
): boolean {
  if (!user || typeof user !== "object") return false;
  if (hasRole(user, "ADMIN")) return true;
  return (
    hasRole(user, "PROFESSIONAL") &&
    hasFeatureAccess(sub.subscriptionTier, FeatureAccess.BE_BOOKED_PROFESSIONAL, {
      subscriptionStatus: sub.subscriptionStatus,
    })
  );
}

/** Instructor admin / teaching panel access. */
export function canAccessInstructorPanel(
  user: unknown,
  _sub?: PanelSwitcherSubscription
): boolean {
  return canAccessCertificateAdmin(user);
}

export function canAccessCertificateAdmin(user: unknown): boolean {
  if (!user || typeof user !== "object") return false;
  return hasRole(user, "ADMIN") || hasRole(user, "INSTRUCTOR");
}

/** Backwards-compatible alias for older layout code. */
export const canAccessTeachingPanel = canAccessInstructorPanel;

